"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/** @deprecated `@faire/slate/icons/TaskList` instead */
export const TaskList = createSVGIcon(
  <g clipPath="url(#clip0_5364_1095)" stroke="currentColor">
    <path
      d="M21 20.885c0 .428-.172.839-.48 1.142a1.65 1.65 0 0 1-1.156.473H4.636c-.434 0-.85-.17-1.157-.473A1.6 1.6 0 0 1 3 20.885V3.115c0-.428.172-.839.48-1.142A1.65 1.65 0 0 1 4.635 1.5h9.14c.435 0 .85.17 1.158.473l5.587 5.515c.306.303.479.714.479 1.143zM12.914 10.99h4.09M12.914 16.594h4.09"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m6.586 16.502 1.371 1.354 2.285-3.158M6.586 10.798l1.371 1.353 2.285-3.158"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </g>,
  "TaskList",
  { viewBox: "0 0 24 24", fill: "none", color: Core.icon.default } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
